import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const editAnswer = async (payload: Partial<IObservationAnswerPayload>) => {
	const url = `/observations/responses/${payload.id}/`;

	const response = await cmsClient.put<IObservationForm>(url, payload);
	return response.data;
};

const useEditAnswer = () => {
	const mutation = useMutation(editAnswer);

	return mutation;
};

export default useEditAnswer;
